<template>
  <div class="bluefire-wap-wrap">
    <div v-if="errorNotice" align="center" class="notice">
      <i class="notice-icon el-icon-info"></i>
      <template v-if="errorNotice && errorNotice.indexOf('hint') >= 0">
        <p class="notice-title">系统或接口错误</p>
        <el-alert :title="errorNotice" type="info" style="width:80%;text-align: left"></el-alert>
      </template>
      <p v-else class="notice-title">{{ errorNotice }}</p>
    </div>

    <div v-else v-loading="loading.status">
      <el-tabs v-model="tabsActive" v-if="externalUserid">
        <el-tab-pane label="客户详情" name="person">
          <el-form ref="form" label-width="80px" style="padding-right: 4vw;">
            <el-form-item label="所属系统:">
              <el-select
                v-model="crmInfo.sitename"
                clearable
                :disabled="bindStatus !== 0"
                placeholder="请选择">
                <el-option
                  v-for="item in dictSite"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="客户编码:">
              <el-input
                placeholder="请输入内容"
                :disabled="bindStatus !== 0"
                v-model="crmInfo.userid"
              >
              </el-input>
            </el-form-item>

            <template v-if="bindStatus !== 0">
              <el-form-item label="姓名:">
                <el-input
                  placeholder="请输入内容"
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.username"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="电话:">
                <el-input
                  placeholder="请输入内容"
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.tel"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="微信:">
                <el-input
                  placeholder="请输入内容"
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.wechat"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="客户分级:" v-if="crmInfo.sitename === 'fib'">
                <jm-dict-select
                  type="dataset"
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.crm_level_lv"
                  clearable
                  dict-type="student"
                  :filter="filterCrmLevel"
                  name="customLvType"/>
              </el-form-item>
              <el-form-item label="客户状态:" v-if="crmInfo.sitename === 'training'">
                <jm-dict-select
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.customer_status"
                  clearable
                  type="dataset"
                  dict-type="training"
                  name="trainingLevelType"
                />
              </el-form-item>
              <el-form-item label="意向分级:" v-show="crmInfo.sitename === 'training'">
                <jm-dict-select
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.customer_classify"
                  clearable
                  type="dataset"
                  dict-type="training"
                  name="trainingLvType"
                />
              </el-form-item>

              <el-form-item label="备注:">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  :disabled="bindStatus < 0"
                  v-model="crmInfo.memo"
                >
                </el-input>
              </el-form-item>
            </template>

            <el-form-item label="企微用户:">
              <a v-if="external.remark" href="javascript:void(0)">{{ external.remark }}</a>
              <span v-else>{{ external.name }}</span>
            </el-form-item>
            <el-form-item label="企微标签:" v-if="external.tags && external.tags">
              <el-tag style="margin-right: 2vw" v-for="(item, index) in external.tags" :key="index">
                {{ item.tag_name }}
              </el-tag>
            </el-form-item>
            <el-form-item label="企微电话:">
              <template v-if="external.remark_mobiles && external.remark_mobiles.length">
                <span v-for="(mobile, index) in external.remark_mobiles" :key="index">
                  <a :href="`tel:${mobile}`">{{ mobile }}</a><br />
                </span>
              </template>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="企微备注:">
              <span v-if="external.description">{{ external.description }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="性别:">
              <span v-if="external.gender">{{ external.gender }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="添加时间:">
              <span>{{ external.createtime }}</span>
            </el-form-item>
          </el-form>
          <div class="btns-wrap">
            <el-button type="primary" v-if="bindStatus > -1" @click="savePersonInfo">
              {{ bindStatus !== 0 ? '保存' : '绑定' }}
            </el-button>
            <el-button type="success" v-if="bindStatus > 0" @click="openDailogVisit">添加回访</el-button>
            <!-- <el-button>同步系统</el-button> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="跟进回访" name="visit" v-if="bindStatus > 0">
          <div class="feedback-list-wrap">
            <div class="list-wrap" v-for="v in visitList" :key="v.id">
              <div class="line-area">
                <span>{{ v.instime }}</span>
                <span>{{ v.visit_creator }}</span>
              </div>
              <div class="line-area">
                <span>回访类型：<b>{{ v.visit_type }}</b></span>
                <span v-if="v.visit_kind">方式：<b>{{ v.visit_kind }}</b></span>
              </div>
              <div class="line-area">
                <span>回访记录内容：</span>
                <p>{{ v.vist_str }}</p>
              </div>
            </div>
          </div>
          <div class="pagination-area">
            <el-pagination
              v-if="visitList && visitList.length > 0"
              :current-page.sync="visitCurrentPage"
              layout="prev, pager, next"
              :total="visitPageTotal"
              :page-size="visitPageSize"
              :pager-count="5"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--添加回访弹窗 start-->
    <el-dialog title="添加回访" :visible.sync="dailogVisitVisible" class="dialog">
      <el-form :model="visitShadow" style="padding: 4vw 4vw 0">
        <el-form-item label="参与活动:" label-width="80px">
          <el-select v-model="visitShadow.activity_id" placeholder="请选择">
            <el-option v-for="item in activity[crmInfo.sitename]" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*回访类型:" label-width="80px">
          <jm-dict-select
            clearable
            dict="dataset.visit.type"
            v-model="visitShadow.visit_type"
          />
        </el-form-item>
        <el-form-item label="快捷记录:" label-width="80px">
          <jm-dict-select
            clearable
            dict="dataset.visit.quickRecord"
            v-model="visitShadow.record"
            @change="quickFill"
          />
        </el-form-item>
        <el-form-item label="回访:" label-width="80px">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="visitShadow.vist_str"
            :rows="3"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dailogVisitVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDailogVisit">确 定</el-button>
      </div>
    </el-dialog>
    <!--添加回访弹窗 end-->
  </div>
</template>
<script>
import * as visitDataset from '@/dataset/visit';
import wework from './wework.js';
import {
  jmAreaselect,
  jmEducationSelect,
  jmDictSelect,
  jmUploadFile,
  jmSchoolSearch
} from '@/components/tool';

const dictSite = [
  { id: 'fib', value: '昆仑系统' },
  { id: 'training', value: '星图系统' }
];

export default {
  // mixins: [student, permissionMixin],
  data() {
    return {
      dictSite,
      loading: { // 载入状态
        status: true,
        counter: 0,
      },
      errorNotice: '', // 错误提示
      externalUserid: null, // 企业微信客户ID
      tabsActive: 'person', // 当前选中的tab name
      bindStatus: 0, // -1 不可绑定，0 可绑定， 1 已绑定
      external: { // 企微数据
        name: '',
        avatar: '',
        gender: '',
        description: '',
        createtime: '',
        tags: [],
        remark_mobiles: []
      },
      crmInfo: { // CRM 数据
        sitename: '',
        userid: 0,
        qq: '',
        tel: '',
        wechat: '',
        memo: '',
        crm_level_lv: '', // fib - 客户分级
        customer_status: '', // training - 客户状态
        customer_classify: '', // training - 意向分级
      },
      activity: [],
      visitList: [],
      visitCurrentPage: 1,
      visitPageTotal: 1,
      visitPageSize: 5,
      dailogVisitVisible: false, // 添加回访弹窗锁
      visitShadow: { // 添加回访弹窗数据
        activity_id: '',
        record: '',
        visit_type: '',
        vist_str: ''
      },
    };
  },
  computed: {
  },
  methods: {
    startLoading() {
      this.loading.status = true;
      this.loading.counter++;
    },
    closeLoading(force) {
      this.loading.counter--;
      if (force || this.loading.counter === 0) {
        this.loading.counter = 0;
        this.loading.status = false;
      }
    },
    initPersonInfo(externalUserid) {
      this.externalUserid = externalUserid;
      this.startLoading();
      this.$http._post({
        url: '/wework/index/person',
        data: {
          externalUserid: this.externalUserid,
        }
      })
        .then((res) => {
          if (res.errcode) {
            return Promise.reject(new Error(res.errmsg));
          }
          this.closeLoading();

          this.bindStatus = res.bindStatus;
          this.crmInfo = Object.assign(this.crmInfo, res.crmInfo);
          this.external = Object.assign(this.external, res.external);
        })
        .catch((error) => {
          this.closeLoading(true);
          this.errorNotice = error.message;
        });
    },
    initVisitList(externalUserid, page) {
      this.startLoading();
      this.$http._post({
        url: '/wework/index/visit',
        data: {
          externalUserid: externalUserid,
          page: Number(page) || 1
        }
      })
        .then((res) => {
          if (res.errcode) {
            return Promise.reject(new Error(res.errmsg));
          }
          this.closeLoading();

          this.visitList = res.data;
          this.visitPageTotal = res.total;
          this.visitPageSize = res.per_page;
        })
        .catch((error) => {
          this.closeLoading(true);
          this.$message.error(error.message);
        });
    },
    initActivity() {
      this.startLoading();
      this.$http._post({
        url: '/wework/index/activity',
      })
        .then((res) => {
          if (res.errcode) {
            return Promise.reject(new Error(res.errmsg));
          }
          this.closeLoading();

          this.activity = res.activity;
        // console.info(this.activity);
        })
        .catch((error) => {
          this.closeLoading(true);
          this.$message.error(error.message);
        });
    },
    handleCurrentChange(currentPage) {
      this.initVisitList(this.externalUserid, currentPage);
    },
    savePersonInfo() {
      this.startLoading();
      this.$http._post({
        url: '/wework/index/savePerson',
        data: {
          externalUserid: this.externalUserid,
          data: this.crmInfo
        }
      })
        .then((res) => {
          if (res.errcode) {
            return Promise.reject(new Error(res.errmsg));
          }
          this.closeLoading();
          this.$message.success(`客户信息${this.bindStatus !== 0 ? '保存' : '绑定'}成功`);

          this.bindStatus = res.bindStatus;
          this.crmInfo = Object.assign(this.crmInfo, res.crmInfo);
          this.external = Object.assign(this.external, res.external);
        })
        .catch((error) => {
          this.closeLoading(true);
          this.$message.error(error.message);
        });
    },
    openDailogVisit() {
      this.dailogVisitVisible = true;
    },
    submitDailogVisit() {
      if (!this.visitShadow.visit_type) {
        this.$message.error('请选择回访类型');
        return false;
      }

      this.startLoading();
      this.$http._post({
        url: '/wework/index/addVisit',
        data: {
          externalUserid: this.externalUserid,
          data: this.visitShadow
        }
      })
        .then((res) => {
          if (res.errcode) {
            return Promise.reject(new Error(res.errmsg));
          }
          this.closeLoading();
          this.dailogVisitVisible = false;
          this.tabsActive = 'visit';
          this.handleCurrentChange(1);
        })
        .catch((error) => {
          this.closeLoading(true);
          this.$message.error(error.message);
        });
    },
    quickFill(v) {
      visitDataset.quickRecord.forEach((item) => {
        if (item.value === v) {
          this.visitShadow.vist_str = item.label;
        }
      });
    },
    filterCrmLevel(item) {
      return !!item;
    },
    setWebMeta: function() {
      let oMeta = document.createElement('meta');
      oMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=0';
      oMeta.name = 'viewport';
      document.getElementsByTagName('head')[0].appendChild(oMeta);
    },
  },
  watch: {

  },
  beforeRouteEnter(to, from, next) {
    // 设置调试数据，以便在web打开
    // wework._debug.setData('QinTao', 'wmBhvpCgAA15qFcooy3IQ748GwgPjCdg'); // 测试-春旭(trainign)
    // wework._debug.setData('QinTao', 'woBhvpCgAAKkvWRZtGXkZJ9vq8L7e-kg'); // 测试-朱 (fib)

    wework.authorizeCropUser()
      .then((authorized) => {
        if (authorized) {
          next();
        } else {
        // 跳出去进行OAuth验证
          wework.jumpToAuthorizeUri();
        }
      })
      .catch((error) => {
        next((vm) => {
          vm.errorNotice = error.message;
        });
      });
  },
  created() {
    // 获取当前客户
    wework.getCurExternalContact()
      .then((externalUserid) => {
        this.initPersonInfo(externalUserid);
        this.initVisitList(externalUserid, this.visitCurrentPage);
      }).catch((error) => {
        // this.loading = false;
        this.errorNotice = error.message;
      });
    this.setWebMeta();
  },
  mounted() {
    this.initActivity();
  },
  components: {
    jmAreaselect,
    jmEducationSelect,
    jmDictSelect,
    jmUploadFile,
    jmSchoolSearch,
  }
};
</script>
<style scoped>
  .bluefire-wap-wrap{
    background: #fff;
    padding: 0
  }
  .notice {
    margin-top: 100px;
  }
  .notice-icon{
    font-size:64px;
    color:#409eff;
  }
  .notice-title {
    margin-top:32px;
    margin-bottom:16px;
    color:#333;
    font-size:16px;
  }
  .btns-wrap{
    width: 100%;
    text-align: center;
    background: #fff;
    padding: 4vw 0;
  }
  .feedback-list-wrap{
    padding: 0 4vw;
  }
  .list-wrap{
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 4vw;
    margin-bottom: 4vw;
  }
  .list-wrap .line-area{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
  }
  .tools-wrap .tools-list .btn-area{
    display: inline-block;
    width: 100%;
    border-radius: 1.5vw;
    box-shadow: 0px 0px 8px rgba(146, 146, 146, 0.25);
    margin-right: 3.6vw;
    text-align: center;
    margin-bottom: 3.6vw;
  }
  .list-wrap .line-area span{
    white-space: nowrap;
    line-height: 7vw;
    color: #333
  }
  .list-wrap .line-area b{
    font-weight: normal;
    color: #ff3f3f;
  }
  .list-wrap .line-area p{
    line-height: 7vw;
    color: #777;
    width: 100%;
    word-break: break-all;
  }
  .pagination-area{
    text-align: center;
    padding: 0 0 4vw;
  }
</style>
